import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { map } from "rxjs/operators";
import { PaginatedGenericDto } from "@models/paginated-generic.dto";
import { PaginatedEntityResults } from "@jack-sparrow-libraries/store";

@Injectable()
export class PaginationInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<unknown>, next: HttpHandler) {
		return next.handle(req).pipe(
			map((event: HttpEvent<unknown>) => {
				if (!(event instanceof HttpResponse) || !this.isPaginatedResponse(event)) {
					return event;
				}
				return event.clone({
					body: this.toPaginatedEntityResults(event as HttpResponse<PaginatedGenericDto<unknown>>),
				});
			}),
		);
	}

	private toPaginatedEntityResults(
		response: HttpResponse<PaginatedGenericDto<unknown>>,
	): PaginatedEntityResults<unknown> {
		return {
			hasNextPage: !!response.body?.nextPage,
			entities: response.body?.resultats.liste,
			totalCount: response.body?.nombreTotal,
		};
	}

	private isPaginatedResponse(response: HttpResponse<unknown>): boolean {
		return (
			response.body &&
			Object.prototype.hasOwnProperty.call(response.body, "page") &&
			Object.prototype.hasOwnProperty.call(response.body, "limit") &&
			Object.prototype.hasOwnProperty.call(response.body, "nombrePages") &&
			Object.prototype.hasOwnProperty.call(response.body, "nombreTotal") &&
			Object.prototype.hasOwnProperty.call(response.body, "resultats")
		);
	}
}
